__turbopack_export_value__({
  "body-logo-18": "ShowMoreButtonWrapper-module-scss-module__vM945a__body-logo-18",
  "body-text-12": "ShowMoreButtonWrapper-module-scss-module__vM945a__body-text-12",
  "body-text-14": "ShowMoreButtonWrapper-module-scss-module__vM945a__body-text-14",
  "body-text-16": "ShowMoreButtonWrapper-module-scss-module__vM945a__body-text-16",
  "body-text-18": "ShowMoreButtonWrapper-module-scss-module__vM945a__body-text-18",
  "body-text-20": "ShowMoreButtonWrapper-module-scss-module__vM945a__body-text-20",
  "body-text-24": "ShowMoreButtonWrapper-module-scss-module__vM945a__body-text-24",
  "body-text-24-2": "ShowMoreButtonWrapper-module-scss-module__vM945a__body-text-24-2",
  "body-text-heading-2": "ShowMoreButtonWrapper-module-scss-module__vM945a__body-text-heading-2",
  "body-text-heading-3": "ShowMoreButtonWrapper-module-scss-module__vM945a__body-text-heading-3",
  "body-text-medium-14": "ShowMoreButtonWrapper-module-scss-module__vM945a__body-text-medium-14",
  "body-text-medium-16": "ShowMoreButtonWrapper-module-scss-module__vM945a__body-text-medium-16",
  "body-text-medium-18": "ShowMoreButtonWrapper-module-scss-module__vM945a__body-text-medium-18",
  "body-text-medium2-18": "ShowMoreButtonWrapper-module-scss-module__vM945a__body-text-medium2-18",
  "body-text2-14": "ShowMoreButtonWrapper-module-scss-module__vM945a__body-text2-14",
  "body-text2-16": "ShowMoreButtonWrapper-module-scss-module__vM945a__body-text2-16",
  "button-primary-text": "ShowMoreButtonWrapper-module-scss-module__vM945a__button-primary-text",
  "button-text": "ShowMoreButtonWrapper-module-scss-module__vM945a__button-text",
  "button2-text": "ShowMoreButtonWrapper-module-scss-module__vM945a__button2-text",
  "card-shadow": "ShowMoreButtonWrapper-module-scss-module__vM945a__card-shadow",
  "effect-menu": "ShowMoreButtonWrapper-module-scss-module__vM945a__effect-menu",
  "header-1": "ShowMoreButtonWrapper-module-scss-module__vM945a__header-1",
  "main-container": "ShowMoreButtonWrapper-module-scss-module__vM945a__main-container",
  "main-footer-container": "ShowMoreButtonWrapper-module-scss-module__vM945a__main-footer-container",
  "main-header-container": "ShowMoreButtonWrapper-module-scss-module__vM945a__main-header-container",
  "txt-12-bold": "ShowMoreButtonWrapper-module-scss-module__vM945a__txt-12-bold",
  "txt-14-bold": "ShowMoreButtonWrapper-module-scss-module__vM945a__txt-14-bold",
  "txt-14-bold-caps": "ShowMoreButtonWrapper-module-scss-module__vM945a__txt-14-bold-caps",
  "txt-14-med": "ShowMoreButtonWrapper-module-scss-module__vM945a__txt-14-med",
  "txt-16-bold": "ShowMoreButtonWrapper-module-scss-module__vM945a__txt-16-bold",
  "txt-16-med": "ShowMoreButtonWrapper-module-scss-module__vM945a__txt-16-med",
  "txt-18-bold": "ShowMoreButtonWrapper-module-scss-module__vM945a__txt-18-bold",
  "txt-18-medium": "ShowMoreButtonWrapper-module-scss-module__vM945a__txt-18-medium",
  "txt-18-medium-24": "ShowMoreButtonWrapper-module-scss-module__vM945a__txt-18-medium-24",
  "txt-24-semi": "ShowMoreButtonWrapper-module-scss-module__vM945a__txt-24-semi",
  "wrapper": "ShowMoreButtonWrapper-module-scss-module__vM945a__wrapper",
  "wrapper__showMore": "ShowMoreButtonWrapper-module-scss-module__vM945a__wrapper__showMore",
});
